import React from 'react';
import { useSelector } from 'react-redux';
import DTQuestionOrInstructionView from '../../DTQuestionOrInstructionView';
import ButtonList from '../../Common/ButtonList/ButtonList';
import Question from '../../Common/Question/Question';
import { getDecisionNodeAtPath } from '../../../../../../extractFromState';
import { setAnchorElementsTarget } from '../../../../../../util';
import { InstructionsContainer } from './DTInstructionsNode.styles';

const DTInstructionsNode = () => {
  const decisionNode = useSelector(getDecisionNodeAtPath);

  const renderInstruction = () => {
    if (decisionNode?.confirmInstructions) {
      return (
        <InstructionsContainer
          dangerouslySetInnerHTML={{ __html: setAnchorElementsTarget(decisionNode?.confirmInstructions) }}
        />
      );
    }
  };

  const renderOptions = () => {
    return (
      <>
        {renderInstruction()}
        <ButtonList isButtonDisabled={false} />
      </>
    );
  };

  return <DTQuestionOrInstructionView titleSection={<Question />} options={renderOptions()} loading={false} />;
};

export default DTInstructionsNode;
